import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import OSS from 'ali-oss'; // eslint-disable-next-line @typescript-eslint/no-unused-vars

export var region = 'https://oss-cn-beijing.aliyuncs.com';
export var endpoint = 'https://oss-cn-beijing.aliyuncs.com';
export var overrideFuncNames = ['copy', 'delete', 'deleteMulti', 'put', 'multipartUpload', 'list'];
export var TokenHandler = /*#__PURE__*/function () {
  function TokenHandler(options) {
    _classCallCheck(this, TokenHandler);

    this.options = options;
    this.ossInstance = null;
  }

  _createClass(TokenHandler, [{
    key: "getClient",
    value: function () {
      var _getClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var force,
            getOSSTokenProxyForcibly,
            ossToken,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                force = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;

                if (!TokenHandler.getTokenPromise) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return TokenHandler.getTokenPromise;

              case 4:
                getOSSTokenProxyForcibly = function getOSSTokenProxyForcibly() {
                  if (TokenHandler.ossToken && Date.now() - TokenHandler.prevTokenTime < 60 * 1000) {
                    return Promise.resolve(TokenHandler.ossToken);
                  } // 只有失效时的强制请求才做记录


                  if (force) {
                    TokenHandler.prevTokenTime = Date.now();
                  }

                  return _this.options.getOSSToken();
                };

                if (!(!this.ossInstance || force)) {
                  _context.next = 8;
                  break;
                }

                ossToken = TokenHandler.ossToken;
                return _context.abrupt("return", TokenHandler.getTokenPromise = (ossToken && !force ?
                /* 共享token */
                Promise.resolve(ossToken) : getOSSTokenProxyForcibly()).then(function (token) {
                  TokenHandler.ossToken = ossToken = token; // 清空获取token的Promise

                  TokenHandler.getTokenPromise = null;

                  try {
                    return _this.ossInstance = new OSS({
                      bucket: _this.options.bucket,
                      region: region,
                      endpoint: endpoint,
                      accessKeyId: ossToken.AccessKeyId,
                      accessKeySecret: ossToken.AccessKeySecret,
                      stsToken: ossToken.SecurityToken
                    });
                  } catch (error) {
                    var _this$options$onError, _this$options;

                    TokenHandler.ossToken = null;
                    (_this$options$onError = (_this$options = _this.options).onError) === null || _this$options$onError === void 0 ? void 0 : _this$options$onError.call(_this$options, ossToken);
                    throw ossToken;
                  }
                }));

              case 8:
                return _context.abrupt("return", this.ossInstance);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getClient() {
        return _getClient.apply(this, arguments);
      }

      return getClient;
    }()
    /**
     * 私有api 用于测试 外部禁止使用
     * @param oss
     */

  }, {
    key: "replaceClient",
    value: function replaceClient(oss) {
      if (process.env.NODE_ENV === 'test') {
        this.ossInstance = oss;
      }
    }
  }]);

  return TokenHandler;
}();
TokenHandler.ossToken = null;
TokenHandler.getTokenPromise = null;
TokenHandler.prevTokenTime = 0;